module.exports = __webpack_public_path__ + "img/idphoto_null@3x.0a6c83c1.png";